import { IApplicationState } from '../../types/store';

export const selectIsMobile = (state: IApplicationState): boolean => {
  return state.mobile.isMobileVersion;
};
